import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsSurfingNormalSmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M9.26 23.445l.571-.466c.126-.1 3.124-2.584 6.766-9.434C20.34 6.507 19.192 2.273 18.51.746l-.265-.494-.536.095c-1.61.282-5.762 1.7-9.5 8.736-3.643 6.845-4.08 10.684-4.098 10.844l-.079.745H7.39zm8.453-20.69c.344 1.859.3 5.24-2.308 10.156a36.66 36.66 0 01-5.884 8.508l-.986-1.462 9.178-17.202zM5.588 19.323A38.293 38.293 0 019.4 9.717c2.591-4.871 5.346-6.8 7.115-7.578L7.343 19.323z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSurfingNormalSmall.defaultProps = {
  color: 'currentColor',
  size: 24,
  title: undefined,
  titleId: undefined
};
SvgSportsSurfingNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsSurfingNormalSmall;
